import React from "react";
import { Tooltip, Button } from "@material-ui/core";
import PostAddIcon from "@material-ui/icons/PostAdd";

const CustomIconButton = ({
    title = "",
    color = "secondary",
    variant = "contained",
    icon = <PostAddIcon />,
    onClick,
    style = {},
    otherProps = {},
}) => {
    return (
        <Tooltip title={title}>
            <Button color={color} variant={variant} onClick={onClick} style={style} {...otherProps}>
                {icon}
            </Button>
        </Tooltip>
    );
};

export default CustomIconButton;
